import React , {useState,useEffect} from 'react'
import { Link } from "react-router-dom";
import { emptyAvatar } from "../../imagepath";
import { getFile } from "../../../lib/file"
import { getIdData } from "../../../lib/studentinfo"


// eslint-disable-next-line react/prop-types
export default function StudentGridBox({data}) {




    const { studentId } = data;
    //console.log("StudentGridBox",studentId);
    const [avatar, setAvatar] = useState();
    const [profiles, setProfiles] = useState([]);

    //console.log("profils",profiles);

    async function GetData() {
      const profils = await getIdData(studentId);
      setProfiles(profils[0]);

      if(profils[0]?.avatar_url)
      {  const avt = await getFile(profils[0]?.avatar_url);
        setAvatar(avt.publicUrl);}

       // console.log("profils",profils);
    }

    useEffect(() => {
        GetData();
    }, [studentId])

    return profiles ? (
      <div className='col-xl-4 col-lg-6 col-md-6 d-flex' key={profiles.id}>
        <div className='student-box flex-fill bg-white'>
          <div className='student-box-blks'>
            <div className='student-img'>
              <Link to={`/instructor/instructor-studenttask/${profiles.id}`}>
                <img
                  className='img-fluid rounded-circle'
                  alt='Students Info'
                  src={avatar ? avatar : emptyAvatar}
                />
              </Link>
            </div>
            <div className='student-content pb-0'>
              <h5>
                <Link to={`/instructor/instructor-studenttask/${profiles.id}`}>
                  {profiles.name + ' ' + profiles.surname}
                </Link>
              </h5>
              <div className='loc-blk d-flex align-items-center justify-content-center'>
                <i className='feather-map-pin me-2'></i>
                <p>{profiles.schoolname}</p>
              </div>
            </div>
          </div>
          <div className='enrol-student-foot'>
            <ul>
              <li>
                Class : <h6> {profiles.class} </h6>
              </li>
              <li>
                Progress
                <div className='instruct-stip d-flex align-items-center'>
                  {profiles.isActive ? (
                    <i className='fas fa-circle-check green h3'></i>
                  ) : (
                    <i className='fas fa-minus-circle red h3'></i>
                  )}
                </div>
              </li>
            </ul>
          </div>
          <Link
            to={`/instructor/student-profile-edit/${profiles.id}`}
            className='update_btn_for_students'
          >
            UPDATE
          </Link>
        </div>
      </div>
    ) : (
      ''
    )
}
